/**
 * @class Helper
 * Helper functions that are used throughout the platform.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import APIHelper from './APIHelper';
import AuthUser from './AuthUser';
import { Buffer } from 'buffer/';
//====================================================================
export const GetAuthRoutes = () => {
    return [
        {
            path: '/passback',
            name: 'passback',
            meta: {
                noAuthRequired: true,
            },
        },
        {
            path: '/logout',
            name: 'logout',
            meta: {
                noAuthRequired: true,
            },
        },
    ];
};
export const RouterBeforeEach = (to, _from, next = () => { }) => new Promise((resolve) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (to.name === 'passback') {
        //Handle auth callback
        yield APIHelper.handleCallback(to);
    }
    else if (to.name === 'logout') {
        //Handle auth callback
        yield APIHelper.handleLogout();
        window.location.href = 'https://archistar.ai';
        if (window.Appcues)
            window.Appcues.page();
        resolve(1);
        next();
    }
    else if (
    // Auth route
    !to.meta.hasOwnProperty('noAuthRequired') ||
        !to.meta.noAuthRequired) {
        if (to.query.jwt) {
            // Token present - use once & continue on
            APIHelper.setJwtOverride(to.query.jwt);
            APIHelper.AuthAPIs.forEach((itApi) => {
                itApi.setHeaderCommons('Authorization', 'Bearer ' + to.query.jwt);
            });
            if (!AuthUser.exists())
                yield AuthUser.fetch(to);
            if (window.Appcues)
                window.Appcues.page();
            resolve(1);
            next();
        }
        else {
            if (!APIHelper.isUserLoggedIn()) {
                //Redirect for login
                if (!APIHelper.getCurrentRefreshToken()) {
                    //No logged in user
                    yield APIHelper.handleLogin(to);
                }
            }
            else {
                // Get userinfo if none is present
                if (!AuthUser.exists()) {
                    if (to.query.action === 'user_app_link' && typeof to.query.u !== 'undefined') {
                        // On user_app_link so check that correct user is logged in
                        var authUserInfoResp = yield APIHelper.AuthAPI.get('/user/details');
                        var buffAppLinkUserGuid = Buffer.from(to.query.u.toString(), 'base64');
                        var appLinkUserGuid = buffAppLinkUserGuid.toString();
                        if (!authUserInfoResp || ((_b = (_a = authUserInfoResp.data) === null || _a === void 0 ? void 0 : _a.userData) === null || _b === void 0 ? void 0 : _b.guid) != appLinkUserGuid) {
                            // Correct user not logged in.  log them out an do a new login
                            yield APIHelper.handleLogout();
                            yield APIHelper.handleLogin(to);
                        }
                        else {
                            yield AuthUser.fetch(to);
                        }
                    }
                    else {
                        yield AuthUser.fetch(to);
                    }
                }
                if (window.Appcues)
                    window.Appcues.page();
                resolve(1);
                next();
            }
        }
    }
    else {
        if (window.Appcues)
            window.Appcues.page();
        resolve(1);
        next();
    }
}));
export const RouterAfterEach = (_to, _from) => new Promise((resolve) => __awaiter(void 0, void 0, void 0, function* () {
    if (window.Appcues)
        window.Appcues.page();
    resolve(1);
}));
export const GetFullStoryUserObject = (authUserInfo) => {
    var _a, _b;
    return {
        // User
        email: authUserInfo.email,
        displayName: (_b = (_a = authUserInfo.firstName) !== null && _a !== void 0 ? _a : '' + authUserInfo.lastName) !== null && _b !== void 0 ? _b : '',
    };
};
export const GetUserData = (authUserInfo) => ({
    displayName: (authUserInfo.firstName || '') + (authUserInfo.lastName || ''),
    user_email: authUserInfo.email || '-',
    user_first_name: authUserInfo.firstName || '-',
    user_last_name: authUserInfo.lastName || '-',
    user_last_login_date: authUserInfo.lastLogin || '-',
    user_company_names: userCompanyNames(authUserInfo) || '-',
    user_profession: (authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.profession) || '-',
});
export const GetSubscriptionData = (authUserInfo) => {
    var _a, _b, _c, _d;
    // Get latest subscription by contract_start_date
    const sortedSubs = userSortedSubs(authUserInfo);
    const latestSubs = sortedSubs.length > 0 ? sortedSubs[0] : null;
    return {
        // Last Subscription
        subscription_archistar: ((_a = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _a === void 0 ? void 0 : _a.Archistar) || '-',
        subscription_archistar_package: ((_b = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _b === void 0 ? void 0 : _b.Archistar_Subscriptions) || '-',
        subscription_academy: ((_c = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _c === void 0 ? void 0 : _c.Academy) || '-',
        subscription_academy_package: ((_d = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _d === void 0 ? void 0 : _d.Academy_Subscriptions) || '-',
        subscription_region_names: JSON.stringify((latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.region_names) || []),
        subscription_start_date: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.subsc_start) || '-',
        subscription_renewal_date: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.subsc_end) || '-',
        subscription_contract_term: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.contract_term_months) || '-',
        subscription_status: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.status) || '-',
        subscription_is_trial: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.is_trial) || '-',
        subscription_tags: JSON.stringify((latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.tags) || [])
    };
};
export const GetAppcuesUserObject = (authUserInfo) => {
    var _a, _b, _c, _d;
    // Get latest subscription by contract_start_date
    const sortedSubs = userSortedSubs(authUserInfo);
    const latestSubs = (sortedSubs === null || sortedSubs === void 0 ? void 0 : sortedSubs.length) > 0 ? sortedSubs[0] : null;
    return {
        // User
        user_email: authUserInfo.email || '-',
        user_first_name: authUserInfo.firstName || '-',
        user_last_name: authUserInfo.lastName || '-',
        user_last_login_date: authUserInfo.lastLogin || '-',
        user_company_names: userCompanyNames(authUserInfo) || '-',
        user_profession: (authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.profession) || '-',
        subscription_history: JSON.stringify(getSubscHistory(authUserInfo)),
        // Last Subscription
        subscription_archistar: ((_a = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _a === void 0 ? void 0 : _a.Archistar) || '-',
        subscription_archistar_package: ((_b = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _b === void 0 ? void 0 : _b.Archistar_Subscriptions) || '-',
        subscription_academy: ((_c = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _c === void 0 ? void 0 : _c.Academy) || '-',
        subscription_academy_package: ((_d = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.appAccess) === null || _d === void 0 ? void 0 : _d.Academy_Subscriptions) || '-',
        subscription_region_names: JSON.stringify((latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.region_names) || []),
        subscription_start_date: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.subsc_start) || '-',
        subscription_renewal_date: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.subsc_end) || '-',
        subscription_contract_term: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.contract_term_months) || '-',
        subscription_status: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.status) || '-',
        subscription_is_trial: (latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.is_trial) || '-',
        subscription_tags: JSON.stringify((latestSubs === null || latestSubs === void 0 ? void 0 : latestSubs.tags) || [])
    };
};
export const GetSentryUserObject = (authUserInfo) => {
    return {
        email: authUserInfo.email,
        username: authUserInfo.firstName,
    };
};
export const GetActiveCountryCookie = () => {
    return GetCookie('asCountryCode');
};
export const SetCrossSubdomainCookie = (name, value, days) => {
    const assign = name + '=' + escape(value) + ';';
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString() + ';';
    const path = 'path=/;';
    let domain = 'domain=' + window.location.hostname.match(/([^.]+.[^.]+)$/gm) + ';';
    document.cookie = assign + expires + path + domain;
};
export const GetCookie = (cname) => {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
const userSortedSubs = (authUserInfo) => authUserInfo.subscriptions
    .slice()
    .sort((a, b) => a.subsc_start < b.subsc_start ? 1 : -1);
const userCompanyNames = (authUserInfo) => {
    var _a;
    return (_a = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.companies) === null || _a === void 0 ? void 0 : _a.filter((c) => c.name).map((c) => c.name).join(';');
};
export const getSubscHistory = (authUserInfo) => authUserInfo.subscriptionHistory
    .map((s) => (({ label, status, region_names, tags }) => ({ label, status, region_names, tags }))(s));
